import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/platform-advances';

export class PlatformAdvanceService extends RestServiceConnection {
    listPlatformAdvances = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    };

    importPlatformAdvances = async (file: File) => {
        const formData = new FormData();
        formData.append('platformAdvancesExcelFile', file);

        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import-xlsx',
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        }, true) as AxiosResponse;

        return this;
    };
}
